import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BarChart3, ChevronDown, Plus, Settings, Users, Zap } from 'lucide-react';
import { Button } from '@/components/ui-kit/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui-kit/dropdown-menu';
import type { UserRole } from '@/state/store/auth/index.type';

interface AdminDashboardQuickActionsMenuProps {
  userRole: UserRole;
}

export function AdminDashboardQuickActionsMenu({ userRole }: AdminDashboardQuickActionsMenuProps) {
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="primary" size="sm" aria-label={t('ADMIN_DASHBOARD_QUICKACTIONS_TITLE')}>
          <Zap className="h-4 w-4" />
          {t('ADMIN_DASHBOARD_QUICKACTIONS_TITLE')}
          <ChevronDown className="h-3.5 w-3.5 opacity-80" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="flex items-center gap-2">
          <Zap className="h-3.5 w-3.5 text-selise-blue" />
          {t('ADMIN_DASHBOARD_QUICKACTIONS_TITLE')}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/admin/templates/new" className="cursor-pointer">
            <Plus className="mr-2 h-4 w-4" />
            {t('ADMIN_DASHBOARD_QUICKACTIONS_ADDTEMPLATE')}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/admin/settings" className="cursor-pointer">
            <Settings className="mr-2 h-4 w-4" />
            {t('ADMIN_DASHBOARD_QUICKACTIONS_OPENSETTINGS')}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/admin/analytics" className="cursor-pointer">
            <BarChart3 className="mr-2 h-4 w-4" />
            {t('ADMIN_DASHBOARD_QUICKACTIONS_VIEWANALYTICS')}
          </Link>
        </DropdownMenuItem>
        {userRole === 'sys_admin' && (
          <DropdownMenuItem asChild>
            <Link to="/admin/users" className="cursor-pointer">
              <Users className="mr-2 h-4 w-4" />
              {t('ADMIN_DASHBOARD_QUICKACTIONS_MANAGEUSERS')}
            </Link>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
